(async () => {
  // MAIN JS
  const shareBtns = document.querySelector('.sharethis-inline-share-buttons');
  const shareTrigger = document.querySelector('.pdp__main__share__trigger');
  // SHARE BTN
  try {
    shareTrigger.addEventListener('click', () => {
      shareTrigger.nextElementSibling.classList.add('pdp__main__share__wrapper--open');
    });
    let added = false;
    const shareObserver = new MutationObserver((list, observer) => {
      if (!added) {
        added = true;
        const copyButton = document.createElement('button');
        copyButton.classList.add('pdp__main__share__copy');
        copyButton.setAttribute('tabindex', '0');
        const closeButton = document.createElement('button');
        closeButton.classList.add('pdp__main__share__close');
        closeButton.setAttribute('tabindex', '0');
        closeButton.addEventListener('click', () => {
          shareTrigger.nextElementSibling.classList.remove('pdp__main__share__wrapper--open');
        });
        copyButton.innerHTML = `<div class="pdp__main__share__copy__container"><img
            src="https://cdn.shopify.com/s/files/1/1163/1976/files/copy-white.svg?v=1626467307"
            alt="copy to clipboard"
            width="16"
            height="16"
            loading="lazy"
            style="width: 100%; height: 100%; display: block; object-fit: contain;"
          ></div>Copy`;
        copyButton.addEventListener('click', () => {
          navigator.clipboard.writeText(`https://factorypure.com${globalProduct.url}`).then(() => {
            copyButton.innerText = 'Copied!';
          });
        });
        closeButton.innerHTML = `<svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        fill="white"
        height="12"
        width="12"
        version="1.1"
        viewBox="0 0 460.775 460.775"
        xml:space="preserve"
        style="display: block;"
        aria-label='close share modal'
      >
        <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55  c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55  c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505  c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55  l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719  c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/>
      </svg>`;
        shareBtns.insertBefore(copyButton, shareBtns.children[0]);
        shareBtns.appendChild(closeButton);
      }
    });
    shareObserver.observe(shareBtns, config);
    const descriptionShareBtns = document.querySelector('.js-description-share-btns');
    const descriptionShareTrigger = document.querySelector('.js-description-share-trigger');

    descriptionShareTrigger.addEventListener('click', () => {
      descriptionShareTrigger.nextElementSibling.classList.add('pdp__main__share__wrapper--open');
    });
    let descriptionAdded = false;
    const descriptionShareObserver = new MutationObserver((list, observer) => {
      if (!descriptionAdded) {
        descriptionAdded = true;
        const copyButton = document.createElement('button');
        copyButton.classList.add('pdp__main__share__copy');
        copyButton.classList.add('override__default__button__styles-shareBtns', 'width__full');
        copyButton.setAttribute('tabindex', '0');
        const closeButton = document.createElement('button');
        closeButton.classList.add('pdp__main__share__close');
        closeButton.classList.add('override__default__border__and__font');
        // closeButton.setAttribute('tabindex', '0');
        closeButton.addEventListener('click', () => {
          descriptionShareTrigger.nextElementSibling.classList.remove('pdp__main__share__wrapper--open');
        });
        copyButton.innerHTML = `<div class="pdp__main__share__copy__container"><img
        src="https://cdn.shopify.com/s/files/1/1163/1976/files/copy-white.svg?v=1626467307"
        alt="copy to clipboard"
        width="16"
        height="16"
        loading="lazy"
        style="width: 100%; height: 100%; display: block; object-fit: contain;"
      ></div>Copy`;
        copyButton.addEventListener('click', () => {
          navigator.clipboard.writeText(`https://factorypure.com${globalProduct.url}`).then(() => {
            copyButton.innerText = 'Copied!';
          });
        });
        closeButton.innerHTML = `<svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        fill="white"
        height="12"
        width="12"
        version="1.1"
        viewBox="0 0 460.775 460.775"
        xml:space="preserve"
        style="display: block;"
        aria-label='close share modal'
      >
        <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55  c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55  c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505  c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55  l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719  c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/>
      </svg>`;
        descriptionShareBtns.insertBefore(copyButton, descriptionShareBtns.children[0]);
        descriptionShareBtns.appendChild(closeButton);

        const closeButtons = Array.from(document.querySelectorAll('.pdp__main__share__close'));
        for (const closeBtn of closeButtons) {
          closeBtn.setAttribute('tabindex', '0');
          closeBtn.classList.add('override__default__border__and__font');
        }
        const copyButtons = Array.from(document.querySelectorAll('.pdp__main__share__copy'));
        for (const copyBtn of copyButtons) {
          copyBtn.setAttribute('tabindex', '0');
          copyBtn.classList.add('width__full', 'override__default__border__and__font');
        }
        const shareFirstBtns = Array.from(document.querySelectorAll('.st-btn.st-first.st-remove-label'));
        for (const firstBtn of shareFirstBtns) {
          firstBtn.setAttribute('tabindex', '0');
          firstBtn.classList.add('width__full', 'override__default__border__and__font');
        }
        const lastBtns = Array.from(document.querySelectorAll('.st-btn.st-first.st-remove-label'));
        for (const lastBtn of lastBtns) {
          lastBtn.classList.add('width__full', 'override__default__border__and__font');
          lastBtn.setAttribute('tabindex', '0');
        }
        const shareBtns = Array.from(document.querySelectorAll('.st-btn.st-remove-label'));
        for (const btn of shareBtns) {
          btn.classList.add('override__default__border__and__font', 'width__full');
          btn.setAttribute('tabindex', '0');
        }
      }
    });
    descriptionShareObserver.observe(descriptionShareBtns, config);
  } catch (err) {
    console.log('Share btn err:', err);
  }

  // MAIN ATC FUNCTION
  try {
    const increment = document.querySelectorAll('.js-inc');
    const decrement = document.querySelectorAll('.js-dec');
    const qty = document.querySelector('.js-qty');
    const qtySticky = document.querySelector('.js-qty-sticky');
    const calculatedPrice = document.querySelector('.js-calculated-price');
    const compareAtPrice = document.querySelector('.js-compare-at-price');
    const priceAnchor = document.querySelector('.js-price');
    const totalAvailable = document.querySelector('.js-total-available');

    increment.forEach((increment) => {
      increment.addEventListener('click', () => {
        qty.value++;
        decrement.disabled = false;
        qty.dispatchEvent(new Event('change'));
        qty.dispatchEvent(new Event('input'));
      });
    });
    decrement.forEach((decrement) => {
      decrement.addEventListener('click', () => {
        if (qty.value > 1) {
          qty.value--;
          qty.dispatchEvent(new Event('change'));
          qty.dispatchEvent(new Event('input'));
        }
        if (qty.value < 2) {
          decrement.disabled = true;
          qty.dispatchEvent(new Event('change'));
          qty.dispatchEvent(new Event('input'));
        }
      });
    });

    qty.addEventListener('change', (e) => {
      if (e.target.value <= 1) {
        e.target.value = 1;
        qty.previousElementSibling.disabled = true;
        qtySticky.previousElementSibling.disabled = true;
      } else {
        qty.previousElementSibling.disabled = false;
        qtySticky.previousElementSibling.disabled = false;
      }
      if (e.target.value >= parseInt(totalAvailable.innerText.trim())) {
        e.target.value = parseInt(totalAvailable.innerText);
        qty.nextElementSibling.disabled = true;
        qtySticky.nextElementSibling.disabled = true;
      } else {
        qty.nextElementSibling.disabled = false;
        qtySticky.nextElementSibling.disabled = false;
      }
      calculatedPrice.innerText = (priceAnchor.dataset.priceRaw * e.target.value) / 100;
      qtySticky.value = qty.value;
    });

    const price = priceAnchor.dataset.priceRaw / 100;
    const shippingTrigger = document.querySelector('.js-shipping-trigger');
    const shippingAccordion = document.querySelector('.js-shipping-options');
    if (shippingTrigger) {
      shippingTrigger.addEventListener('click', () => {
        if (shippingAccordion.classList.contains('js-shipping-options--open')) {
          shippingAccordion.classList.remove('js-shipping-options--open');
          shippingAccordion.style.display = '';
        } else {
          shippingAccordion.classList.add('js-shipping-options--open');
          shippingAccordion.style.display = 'block';
        }
      });
    }

    const warrantyBoxes = document.querySelectorAll("input[name='warranty']");
    warrantyBoxes.forEach((box) => {
      box.addEventListener('change', (e) => {
        warrantyBoxes.forEach((b) => b.parentNode.classList.remove('pdp__main__warranty__box--checked'));
        if (e.target.checked) {
          e.target.parentNode.classList.add('pdp__main__warranty__box--checked');
        }
      });
    });

    const atcBtn = document.querySelectorAll('.js-atc-btn');
    const atcText = document.querySelectorAll('.js-atc-text');
    const options = document.querySelectorAll('.js-option');
    const variants = document.querySelectorAll('.js-variant');
    const warrantyVariantMap = {};
    for (const warrantyVariantsJson of Array.from(document.querySelectorAll('.js-warranty-variant'))) {
      const warrantyVariantId = warrantyVariantsJson.dataset.variantId;
      warrantyVariantMap[warrantyVariantId] = JSON.parse(warrantyVariantsJson.innerText);
    }
    const slideoutWarrantyOptions = Array.from(document.querySelectorAll('.js-slideout-warranty'));
    const warrantyOptions = Array.from(document.querySelectorAll('.js-warranty'));
    const warrantyMessage = document.querySelector('.js-warranty-message');
    const shippingOptions = Array.from(document.querySelectorAll("input[name='shipping']"));
    const sellingPlanOptions = Array.from(document.querySelectorAll('.js-selling-plans input'));
    const slideoutAddWarrantyButton = document.querySelector('.js-slideout-add-warranty-btn');
    const productIds = document.querySelector('.js-product-id').children;
    const stockBox = document.querySelector('.js-stock-box');
    const currentSkuBox = document.querySelector('.js-current-sku');
    const restockBox = document.querySelector('.js-restock-box');

    warrantyOptions.forEach((w) =>
      w.addEventListener('change', (e) => {
        if (e.target.checked && e.target.value) {
          if (window.slideout) {
            window.slideout.warrantyAdded = true;
          }
          warrantyMessage.classList.add('pdp__main__warranty__message--added');
        } else {
          if (window.slideout) {
            window.slideout.warrantyAdded = false;
          }
          warrantyMessage.classList.remove('pdp__main__warranty__message--added');
        }
      })
    );
    const moneyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format;
    const getVariantId = (returnEntireElement) => {
      if (options && options.length) {
        const selectedOptions = Array.from(options)
          .filter((o) => o.checked)
          .map((o) => o.value);
        const variantId = Array.from(productIds).find((p) => p.innerText.trim() == selectedOptions.join(' / '));
        if (returnEntireElement) {
          return variantId ? variantId : null;
        } else {
          return variantId ? variantId.dataset.id : null;
        }
      } else if (variants && variants.length) {
        const selectedValue = Array.from(variants).find((v) => v.checked)
          ? Array.from(variants).find((v) => v.checked).value
          : null;
        const variantId = Array.from(productIds).find((p) => p.innerText.trim() == selectedValue);
        if (returnEntireElement) {
          return variantId ? variantId : null;
        } else {
          return variantId ? variantId.dataset.id : null;
        }
      } else {
        return globalProduct.firstVariantId;
      }
    };
    const getSelectedWarranty = () => {
      return Array.from(warrantyOptions).find((w) => w.checked)
        ? parseInt(Array.from(warrantyOptions).find((w) => w.checked).value)
        : null;
    };
    const getSelectedShippingOption = () => {
      return Array.from(shippingOptions).find((s) => s.checked)
        ? parseInt(Array.from(shippingOptions).find((s) => s.checked).value)
        : null;
    };
    const handleOptionsChange = () => {
      const selectedVariantElement = getVariantId(true);
      history.replaceState(
        null,
        '',
        window.location.href.split('?')[0] + `?variant=${selectedVariantElement.dataset.id}`
      );
      const selectedWarrantyVariants = warrantyVariantMap[selectedVariantElement.dataset.id];
      for (let i = 1; i < warrantyOptions.length; i++) {
        const newOptionValue = selectedWarrantyVariants[i - 1];
        const option = warrantyOptions[i];
        const optionPriceElement = option.parentElement.querySelector('.js-warranty-price');
        option.value = newOptionValue.id;
        optionPriceElement.innerText = moneyFormatter(newOptionValue.price / 100);
      }
      for (let i = 0; i < slideoutWarrantyOptions.length; i++) {
        const newOptionValue = selectedWarrantyVariants[i];
        const option = slideoutWarrantyOptions[i];
        const optionPriceElement = option.nextElementSibling.querySelector('.js-slideout-warranty-price');
        option.value = newOptionValue.id;
        optionPriceElement.innerText = ' ' + moneyFormatter(newOptionValue.price / 100).replaceAll('.00', '');
      }
      if (slideoutAddWarrantyButton) {
        slideoutAddWarrantyButton.dataset.variant = selectedVariantElement.dataset.id;
      }
      const selectedPrice = selectedVariantElement ? selectedVariantElement.dataset.price : null;
      const selectedPriceRaw = selectedVariantElement ? selectedVariantElement.dataset.priceRaw : null;
      const selectedMediaPostition = selectedVariantElement ? selectedVariantElement.dataset.mediaPosition : null;
      const selectedPriceCompareAt = selectedVariantElement ? selectedVariantElement.dataset.comparePrice : null;
      const availableString =
        selectedVariantElement.dataset.available.trim() === 'Infinity'
          ? '9999999'
          : selectedVariantElement.dataset.available.trim();
      const availableQuantity =
        selectedVariantElement && parseInt(availableString) <= 0 ? 0 : parseInt(availableString);
      if (globalProduct.title === 'Gift Card') {
        stockBox.style.display = 'none';
      } else {
        if (availableQuantity > 0 && restockBox) {
          if (stockBox && stockBox.parentElement) {
            stockBox.parentElement.style.display = '';
          }
          restockBox.style.display = 'none';
        } else if (restockBox) {
          if (stockBox && stockBox.parentElement) {
            stockBox.parentElement.style.display = 'none';
          }
          restockBox.style.display = '';
        }
      }
      if (selectedPrice) {
        if (compareAtPrice) {
          compareAtPrice.innerHTML = selectedPriceCompareAt;
          compareAtPrice.dataset.comparePrice = selectedPriceCompareAt;
        }
        priceAnchor.innerHTML = selectedPrice;
        priceAnchor.dataset.priceRaw = selectedPriceRaw;
        calculatedPrice.innerText = (priceAnchor.dataset.priceRaw * qty.value) / 100;
        totalAvailable.innerText = availableQuantity;
        currentSkuBox.innerText = selectedVariantElement.dataset.sku;
        if (availableQuantity < qty.value) {
          qty.value = availableQuantity;
          qty.dispatchEvent(new Event('change'));
          qty.dispatchEvent(new Event('input'));
        } else {
          if (qty.value <= 0) {
            qty.value = 1;
            qty.dispatchEvent(new Event('change'));
            qty.dispatchEvent(new Event('input'));
          }
          increment.disabled = false;
        }
      }
      if (selectedMediaPostition) {
        pdpSplide.go(parseInt(selectedMediaPostition));
      }
      atcBtn.forEach((button) => {
        const currentAtcText = button.querySelector('.js-atc-text');
        if (availableQuantity <= 0) {
          button.classList.add('pdp__main__atc__button--disabled');
          button.disabled = true;
          currentAtcText.innerText = 'Out Of Stock';
          stockBox.style.display = 'none';
        } else {
          button.classList.remove('pdp__main__atc__button--disabled');
          button.disabled = false;
          if (button.classList.contains('pdp__main__atc__button--lower-price')) {
            currentAtcText.innerHTML = 'Add To Cart To<br/>See Lower Price';
          } else {
            currentAtcText.innerText = 'Add To Cart';
          }
          if (globalProduct.title !== 'Gift Card') {
            stockBox.style.display = '';
          }
        }
      });
    };
    const getSellingPlan = () => {
      if (!sellingPlanOptions.length) {
        return undefined;
      }
      const selectedPlan = Array.from(sellingPlanOptions).find((input) => input.checked);
      return selectedPlan.value || undefined;
    };
    if (options.length > 0 || variants.length > 0) {
      handleOptionsChange();
    }
    options.forEach((o) => {
      o.addEventListener('change', handleOptionsChange);
    });
    variants.forEach((v) => {
      v.addEventListener('change', handleOptionsChange);
    });
    let messageAdded = false;

    atcBtn.forEach((button) => {
      button.addEventListener('click', () => {
        try {
          const currentAtcText = button.querySelector('.js-atc-text');
          const selectedVariant = getVariantId();
          const selectedWarranty = getSelectedWarranty();
          const selectedShipping = getSelectedShippingOption();
          const amount = parseInt(qty.value) > 0 ? parseInt(qty.value) : 1;
          if (!selectedShipping && shippingOptions && shippingOptions.length) {
            const shippingAlert = document.createElement('div');
            if (!messageAdded) {
              messageAdded = true;
              shippingAlert.classList.add(
                'pdp__main__financial-box__shipping-options__options__alert',
                'pdp__main__financial-box__shipping-options__options__alert--red'
              );
              shippingAlert.innerText = 'Please select a shipping option below, then click add to cart.';
              shippingAccordion.insertBefore(shippingAlert, shippingAccordion.children[0]);
            }
            shippingAccordion.classList.add('js-shipping-options--open');
            shippingAccordion.style.display = 'block';
            if (window.innerWidth < 1000) {
              window.scrollTo({
                top: button.getBoundingClientRect().top + window.scrollY - 75,
                left: 0,
                behavior: 'smooth',
              });
            }
            shippingOptions.forEach((o) => {
              o.addEventListener(
                'change',
                (e) => {
                  if (e.target.checked) {
                    shippingAlert.classList.remove('pdp__main__financial-box__shipping-options__options__alert--red');
                    shippingAlert.classList.add('pdp__main__financial-box__shipping-options__options__alert--blue');
                    shippingAlert.innerText = 'Shipping option added, please click add to cart.';
                  }
                },
                { once: true }
              );
            });
          } else {
            const items = [];
            if (selectedVariant)
              items.push({
                id: selectedVariant,
                quantity: amount,
                selling_plan: getSellingPlan(),
              });
            if (selectedWarranty)
              items.push({
                id: selectedWarranty,
                quantity: amount,
                properties: {
                  product: globalProduct.title.trim(),
                  variant: selectedVariant,
                },
              });
            if (selectedShipping)
              items.push({
                id: selectedShipping,
                quantity: 1,
                properties: {
                  product: globalProduct.title.trim(),
                  variant: selectedVariant,
                },
              });
            const body = {
              items,
            };
            currentAtcText.innerText = 'Adding...';
            if (window.slideout && price < 10000) {
              window.slideout.showWarranty();
            }
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(body),
            })
              .then(() => {
                if (window.slideout) {
                  window.slideout.refresh().then(() => {
                    window.slideout.showCart();
                    if (button.classList.contains('pdp__main__atc__button--lower-price')) {
                      currentAtcText.innerHTML = 'Add To Cart To<br/>See Lower Price';
                    } else {
                      currentAtcText.innerText = 'Add To Cart';
                    }
                  });
                } else {
                  window.location.href = '/cart';
                  if (button.classList.contains('pdp__main__atc__button--lower-price')) {
                    currentAtcText.innerHTML = 'Add To Cart To<br/>See Lower Price';
                  } else {
                    currentAtcText.innerText = 'Add To Cart';
                  }
                }
              })
              .catch(console.log);
          }
        } catch (err) {
          console.log(err);
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: globalProduct.firstVariantId,
                  quantity: 1,
                  selling_plan: getSellingPlan(),
                },
              ],
            }),
          })
            .then(() => (window.location.href = '/cart'))
            .catch(console.log);
        }
      });
    });
  } catch (err) {
    console.log('Catastrophic Failure:', err);
  }

  // MOBILE POPUPS
  try {
    const warrantyTrigger = document.querySelector('.js-warranty-info-trigger');
    const warrantyClose = document.querySelector('.js-warranty-close');
    const shippingInfoTrigger = document.querySelector('.js-shipping-info-trigger');
    const shippingClose = document.querySelector('.js-shipping-close');
    const freeShippingInfoTrigger = document.querySelector('.js-free-shipping-info');
    const freeShippingInfoClose = document.querySelector('.js-free-shipping-close');
    const atcElement = document.querySelector('.js-atc');
    const stickyAtcElement = document.querySelector('.js-sticky-atc');
    const mainElement = document.querySelector('.js-pdp-main');

    if (warrantyTrigger) {
      warrantyClose.addEventListener('click', () => {
        warrantyTrigger.nextElementSibling.classList.remove('pdp__main__warranty__info__content--visible');
        document.querySelector('html').style.overflow = '';
      });
      warrantyTrigger.addEventListener('click', () => {
        warrantyTrigger.nextElementSibling.classList.add('pdp__main__warranty__info__content--visible');
        document.querySelector('html').style.overflow = 'hidden';
      });
    }
    if (shippingInfoTrigger) {
      shippingClose.addEventListener('click', () => {
        shippingInfoTrigger.nextElementSibling.classList.remove('pdp__main__warranty__info__content--visible');
        document.querySelector('html').style.overflow = '';
      });
      shippingInfoTrigger.addEventListener('click', () => {
        shippingInfoTrigger.nextElementSibling.classList.add('pdp__main__warranty__info__content--visible');
        document.querySelector('html').style.overflow = 'hidden';
      });
    }
    if (freeShippingInfoTrigger) {
      freeShippingInfoTrigger.addEventListener('click', (e) => {
        if (window.innerWidth <= 1000) {
          if (e.target.contains(freeShippingInfoClose)) {
            freeShippingInfoTrigger.children[1].classList.remove(
              'pdp__main__financial-box__price-row__shipping__info__popup__wrapper--open'
            );
            document.querySelector('html').style.overflow = '';
          } else {
            freeShippingInfoTrigger.children[1].classList.add(
              'pdp__main__financial-box__price-row__shipping__info__popup__wrapper--open'
            );
            document.querySelector('html').style.overflow = 'hidden';
          }
        }
      });
    }
    const detailsMessages = document.querySelectorAll('.pdp__main__warranty__details__popup');
    detailsMessages.forEach((m) => {
      if (m.getBoundingClientRect().bottom > 300) {
        m.classList.add('pdp__main__warranty__details__popup--above');
        m.classList.remove('pdp__main__warranty__details__popup--below');
      } else {
        m.classList.remove('pdp__main__warranty__details__popup--above');
        m.classList.add('pdp__main__warranty__details__popup--below');
      }
    });
    let debounceScroll = setTimeout(() => {}, 1);
    let debounceHover = setTimeout(() => {}, 1);
    const hoverStates = {};
    detailsMessages.forEach((m, index) => {
      m.parentNode.addEventListener('mouseover', () => {
        clearTimeout(debounceHover);
        hoverStates[index] = true;
      });
      m.parentNode.addEventListener('mouseleave', () => {
        clearTimeout(debounceHover);
        hoverStates[index] = false;
        debounceHover = setTimeout(() => {
          if (m.parentNode.parentNode.getBoundingClientRect().top > window.innerHeight - 300) {
            m.classList.add('pdp__main__warranty__details__popup--above');
            m.classList.remove('pdp__main__warranty__details__popup--below');
          } else {
            m.classList.remove('pdp__main__warranty__details__popup--above');
            m.classList.add('pdp__main__warranty__details__popup--below');
          }
        }, 350);
      });
    });

    window.addEventListener(
      'scroll',
      () => {
        if (window.scrollY > mainElement.offsetTop + mainElement.offsetHeight) {
          stickyAtcElement.classList.add('pdp__main__atc--nav-down');
          stickyAtcElement.classList.remove('pdp__main__atc--nav-up');
        } else {
          stickyAtcElement.classList.add('pdp__main__atc--nav-up');
          stickyAtcElement.classList.remove('pdp__main__atc--nav-down');
        }
        if (window.innerWidth > 1000) {
          detailsMessages.forEach((m, index) => {
            if (m.parentNode.parentNode.getBoundingClientRect().top > window.innerHeight - 300) {
              if (m.offsetHeight > 0) {
                m.addEventListener(
                  'transitionend',
                  () => {
                    m.classList.add('pdp__main__warranty__details__popup--above');
                    m.classList.remove('pdp__main__warranty__details__popup--below');
                  },
                  { once: true }
                );
              } else {
                m.classList.add('pdp__main__warranty__details__popup--above');
                m.classList.remove('pdp__main__warranty__details__popup--below');
              }
            } else {
              if (m.offsetHeight > 0) {
                m.addEventListener(
                  'transitionend',
                  () => {
                    m.classList.remove('pdp__main__warranty__details__popup--above');
                    m.classList.add('pdp__main__warranty__details__popup--below');
                  },
                  { once: true }
                );
              } else {
                m.classList.remove('pdp__main__warranty__details__popup--above');
                m.classList.add('pdp__main__warranty__details__popup--below');
              }
            }
          });
        }
      },
      { passive: true }
    );
  } catch (err) {
    console.log('Popup error:', err);
  }

  // DESCRIPTION JS
  try {
    try {
      const reviewsAnchor = document.querySelector('.js-reviews-total');
      const reviewsSplit = judgemeString.split("data-number-of-reviews='")[1];
      let i = 0;
      while (reviewsSplit[i] !== "'" && i < reviewsSplit.length) {
        i++;
      }
      const reviewsTotal = reviewsSplit.substr(0, i);
      reviewsAnchor.innerHTML = `&nbsp;(${reviewsTotal})`;
    } catch (err) {
      console.log('Judgeme Error: Reviews total not found.');
    }
    if (
      window.innerWidth < 1000 &&
      document.querySelector('.js-compare-mobile-home') &&
      document.querySelector('#custom-compare-product') &&
      document.querySelector('.pdp__related')
    ) {
      document.querySelector('.js-compare-mobile-home').appendChild(document.querySelector('#custom-compare-product'));
      document
        .querySelector('.pdp__related')
        .parentNode.insertBefore(document.querySelector('.pdp__description'), document.querySelector('.pdp__related'));
    }

    let relocationDebounce = setTimeout(() => {}, 200);
    window.addEventListener('resize', () => {
      clearTimeout(relocationDebounce);
      relocationDebounce = setTimeout(() => {
        const mobileHome = document.querySelector('.js-compare-mobile-home');
        const desktopHome = document.querySelector('.js-compare-desktop-home');
        const customCompare = document.querySelector('#custom-compare-product');
        if (mobileHome && desktopHome && customCompare) {
          if (window.innerWidth <= 1000 && !mobileHome.contains(customCompare)) {
            mobileHome.appendChild(customCompare);
            document
              .querySelector('.pdp__related')
              .parentNode.insertBefore(
                document.querySelector('.pdp__description'),
                document.querySelector('.pdp__related')
              );
          } else if (window.innerWidth > 1000 && !desktopHome.contains(customCompare)) {
            desktopHome.appendChild(customCompare);
            document
              .querySelector('.js-product-wrapper')
              .insertBefore(
                document.querySelector('.pdp__description'),
                document.querySelector('.js-product-wrapper').children[0]
              );
          }
        }
      });
    });
  } catch (err) {
    console.log('description error:', err);
  }
  try {
    const currentTime = new Date().toLocaleTimeString('en-US', {
      timeZone: 'America/Chicago',
      hourCycle: 'h23',
    });
    const [hours, minutes] = currentTime.split(':');
    if (parseInt(hours) < 8 || (parseInt(hours) >= 18 && parseInt(minutes) > 30) || parseInt(hours) > 18) {
      document.querySelector('.pdp__main__atc__hours-phone-container').remove();
    }
  } catch (err) {
    console.log('remove hours error:', err);
  }
  // NO QUESTIONS REMOVER
  try {
    const config = { childList: true };
    const judgemeChangeObserver = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          const qaBadge = mutation.target.querySelector('.jdgm-qa-badge');
          if (qaBadge && qaBadge.innerText.includes('No questions')) {
            qaBadge.remove();
          }
        }
      }
    });
    for (const badge of Array.from(document.querySelectorAll('.jdgm-prev-badge'))) {
      judgemeChangeObserver.observe(badge, config);
    }
  } catch {}

  // COMPARE/FAVORITES - GLOBAL VARIABLES //
  // favorites banner timeouts
  let showBannerTimeout = setTimeout(() => {}, 1);
  let hideBannerTimeout = setTimeout(() => {}, 1);

  const productIDString = productID.toString();

  // COMPARE/FAVORITES - EVENT LISTENERS //
  const addToCompares = Array.from(document.querySelectorAll('.js-add__compare'));
  // COMPARE CHECK AND SHOW
  fetch(`https://www.fpapplications.com/comparison/check/products/${productIDString}`)
    .then((res) => res.json())
    .then((res) => {
      console.log(res);
      if (!res.success) {
        return;
      }
      if (res.has_comparison_fields) {
        for (const addToCompare of addToCompares) {
          addToCompare.parentNode.style.display = '';
        }
      }
    })
    .catch(console.error);
  for (const addToCompare of addToCompares) {
    const parsedProduct = {
      id: productIDString,
      title: productTitle,
      featured_image: productImage,
      handle: productHandle,
      sku: productSKU,
    };

    window.compareSlideOutHelper?.checkIfInComparePDP();
    window.compareSlideOutHelper?.checkIfInSideBar();

    // const foundSelectedProduct = selectedCompareProducts.find((product) => product.id == parsedProduct.id);
    // if (foundSelectedProduct) {
    //   addToCompare.style.display = 'none';
    //   removeFromCompare.style.display = 'flex';
    // }

    addToCompare.addEventListener('click', () => {
      const selectedCompareProducts = JSON.parse(localStorage.getItem('selectedCompareProducts') || '[]');
      addToCompare.style.display = 'none';
      addToCompare.nextElementSibling.style.display = 'flex';
      if (addToCompare.nextElementSibling.style.display === 'flex') {
        if (selectedCompareProducts.length === 10) {
          addToCompare.style.display = 'flex';
          addToCompare.nextElementSibling.style.display = 'none';
          return;
        }
        window.compareSlideOutHelper?.addToCompare(parsedProduct);
      } else {
        window.compareSlideOutHelper?.findIndex(parsedProduct.id);
      }
      updateCompareBar();
      window.compareBanner?.hideCompareBar();
      window.compareSlideOutHelper?.checkIfInComparePDP();
      window.compareSlideOutHelper?.checkIfInSideBar();
      document.querySelector('.compare__banner').style.display = 'none';
    });

    // REMOVE FROM COMPARE BUTTON
    addToCompare.nextElementSibling.addEventListener('click', () => {
      addToCompare.nextElementSibling.style.display = 'none';
      addToCompare.style.display = 'flex';

      window.compareSlideOutHelper?.findIndex(parsedProduct.id);
      window.compareSlideOutHelper?.removeFromCompare(parsedProduct.id);
      window.compareSlideOutHelper?.checkIfInComparePDP();
      window.compareSlideOutHelper?.checkIfInSideBar();
      updateCompareBar();
      window.compareBanner?.hideCompareBar();
    });
  }

  // ADD TO FAVORITES/WISHLIST BUTTON
  const addFavoriteButtons = Array.from(document.querySelectorAll('.js-add__fav'));
  const favoritesBanner = document.querySelector('.favorites__banner');

  for (const addFavorite of addFavoriteButtons) {
    addFavorite.addEventListener('click', () => {
      addFavorite.style.display = 'none';
      addFavorite.nextElementSibling.style.display = 'flex';
      favoritesBanner.style.display = 'flex';
      const detectDeviceType = () => (/Mobile|Android|iPhone|iPad/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop');
      const userData = JSON.parse(localStorage.getItem('userData'));

      // FAVORITES FETCH
      fetch('https://www.fpapplications.com/customerFavorites', {
        method: 'POST',
        body: JSON.stringify({
          customer_id: CUSTOMER_ID,
          session_id: SESSION_ID,
          product_id: productID,
          city: userData.city,
          state: userData.region,
          device_type: detectDeviceType(),
          user_agent: window.navigator.userAgent,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((res) => res.json())
        .then((res) => {
          console.log(res, 'res');
          if (res.success) {
            // FAVORITES BANNER
            clearTimeout(showBannerTimeout);
            clearTimeout(hideBannerTimeout);
            showBannerTimeout = setTimeout(() => {
              document.querySelector('.favorites__banner--container').classList.add('favorites__banner--visible');
              document.querySelector('.not__signed__in').style.display = 'none';
            }, 1);
            hideBannerTimeout = setTimeout(() => {
              document.querySelector('.favorites__banner--container').classList.remove('favorites__banner--visible');
            }, 6000);
          } else {
            console.log('something went wrong');
          }
        })
        .then(() => {
          window.wishlistHelper?.refresh();
        });
      // });
      // }
    });

    // REMOVE FROM FAVORITES BUTTON
    addFavorite.nextElementSibling.addEventListener('click', () => {
      addFavorite.style.display = 'flex';
      addFavorite.nextElementSibling.style.display = 'none';
      favoritesBanner.style.display = 'none';
      // fetch('http://localhost:8082/customerFavorites', {
      fetch('https://www.fpapplications.com/customerFavorites', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customer_id: CUSTOMER_ID,
          session_id: SESSION_ID,
          product_id: productID,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          console.log(res, 'res');
          if (res.success) {
            window.wishlistHelper?.refresh();
          }
        });
    });
  }

  function updateCompareBar() {
    const compareProductsContainer = document.querySelector('.collection__compare-products');
    const compareElementsAnchor = document.querySelector('.js-compare-elements-anchor');
    const checkbox = document.querySelector('.js-compareCheckbox');
    const selectedCompareProducts = JSON.parse(localStorage.getItem('selectedCompareProducts') || '[]');
    const compareMap = selectedCompareProducts.map((compare) => ({
      featured_image: compare.featured_image,
      id: compare.id,
      handle: compare.handle,
      title: compare.title,
      sku: compare.sku,
    }));
    compareElementsAnchor.innerHTML = `<p class="collection__compare__bar--text">
           ${
             selectedCompareProducts.length > 1
               ? `<p class="collection__compare__bar--text compare__selected">
                   ${selectedCompareProducts.length} selected
                 </p>`
               : `<p class="collection__compare__bar--text compare__selected">
               Compare up to 10 products
                 </p>`
           }
           <div class="collection__compare__bar--flex">
             ${compareMap
               .map(
                 (compare) => `<div class='compare__and__sku--container'>
                                  <div class='compare__and__sku--wrapper'>
                                    <div class="collection__compare__bar--images">
                                      <a href="/products/${compare.handle}">
                                       <img src=${compare.featured_image} class="collection__compare__bar--selected__product" alt='${compare.title}'/>
                                      </a>
                                      <div style='position:relative; top-0; left-[8px];'>
                                        <button class="collection__compare__bar--x js-removeProductFromCompare" data-id="${compare.id}" id="${compare.id}-removeProductFromCompare" aria-label='remove from compare list'>
                                          <svg 
                                            xmlns="http://www.w3.org/2000/svg" 
                                            fill="#575757" 
                                            width="100%" 
                                            height="100%" 
                                            version="1.1" 
                                            viewBox="144 144 512 512" 
                                            aria-label='x icon'
                                          >
                                            <path d="m563.32 236.68c-26.852-26.84-59.91-46.645-96.246-57.66-36.336-11.016-74.828-12.902-112.07-5.4922-37.238 7.4102-72.074 23.891-101.42 47.977-29.348 24.086-52.305 55.039-66.84 90.117-14.531 35.078-20.188 73.199-16.469 110.98 3.7148 37.785 16.691 74.07 37.781 105.64 21.086 31.574 49.637 57.461 83.117 75.367s70.859 27.281 108.83 27.293c61.219 0.078125 119.96-24.16 163.32-67.383 21.484-21.449 38.531-46.922 50.16-74.965 11.629-28.043 17.617-58.102 17.617-88.461 0-30.355-5.9883-60.418-17.617-88.457-11.629-28.043-28.676-53.516-50.16-74.965zm-74.312 222.73c3.9102 3.9336 6.1055 9.2539 6.1055 14.801 0 5.543-2.1953 10.863-6.1055 14.797-3.9297 3.9102-9.2539 6.1055-14.797 6.1055-5.5469 0-10.867-2.1953-14.801-6.1055l-59.406-59.406-59.41 59.406c-3.9336 3.9102-9.2539 6.1055-14.797 6.1055-5.5469 0-10.867-2.1953-14.801-6.1055-3.9102-3.9336-6.1055-9.2539-6.1055-14.797 0-5.5469 2.1953-10.867 6.1055-14.801l59.406-59.406-59.406-59.41c-3.4375-4.0156-5.2344-9.1797-5.0312-14.465 0.20312-5.2812 2.3945-10.293 6.1328-14.031s8.75-5.9297 14.031-6.1328c5.2852-0.20313 10.449 1.5938 14.465 5.0312l59.41 59.406 59.406-59.406c1.8828-2.1992 4.1992-3.9805 6.8008-5.2422 2.6055-1.2617 5.4414-1.9688 8.3359-2.0781 2.8906-0.11328 5.7695 0.375 8.4648 1.4297 2.6953 1.0547 5.1406 2.6562 7.1875 4.7031 2.043 2.043 3.6445 4.4922 4.7031 7.1836 1.0508 2.6953 1.5391 5.5781 1.4297 8.4688-0.11328 2.8906-0.82031 5.7266-2.082 8.332-1.2578 2.6055-3.043 4.9219-5.2422 6.8008l-59.406 59.41z"/>
                                          </svg>
                                        </button>
                                      </div>
                                    </div>
                                    <div class='product__identifier--collection' aria-label='SKU'>${compare.sku}</div>
                                   </div>
                              </div>`
               )
               .join('\n')}
               ${
                 selectedCompareProducts.length > 5
                   ? `<div class="collection__compare__bar--five__items__showing">+${
                       selectedCompareProducts.length - 5
                     }</div>`
                   : ''
               }
               ${
                 selectedCompareProducts.length > 2
                   ? `<div class="collection__compare__bar--two__items__showing">+${
                       selectedCompareProducts.length - 2
                     }</div>`
                   : ''
               }
              ${
                selectedCompareProducts.length > 1
                  ? `<div class="collection__compare__bar--one__item__showing">+${
                      selectedCompareProducts.length - 1
                    }</div>`
                  : ''
              }
              <div style='display: flex; gap: 10px;'>
                <button class='collection__compare__bar--products__button js-compareButton' tabindex='0'>Compare</button>
                <button class='collection__compare__bar--products__button js-hideCompareButton' tabindex='0'>Hide</button>
              </div>
   `;
    listenToCompareBar();

    /* only display compare bar if an item is selected */
    if (selectedCompareProducts.length === 0) {
      compareProductsContainer.style.display = 'none';
      window.compareBanner?.refresh();
    } else {
      compareProductsContainer.style.display = '';
    }
  }

  window.compare = { updateCompareBar };

  function buildCompareBar() {
    const selectedCompareProducts = JSON.parse(localStorage.getItem('selectedCompareProducts') || '[]');
    const compareMap = selectedCompareProducts.map((compare) => ({
      featured_image: compare.featured_image,
      id: compare.id,
      title: compare.title,
      handle: compare.handle,
      sku: compare.sku,
    }));

    return `
         <div class="collection__compare__bar" style='display: flex;'>
             <div class="compareBarContents" style='padding: 6px;'>
                 <div class="anchor__elements js-compare-elements-anchor">
                 <p class="collection__compare__bar--text">
                 ${
                   selectedCompareProducts.length > 1
                     ? `<p class="collection__compare__bar--text compare__selected">
                       ${selectedCompareProducts.length} selected
                     </p>`
                     : `<p class="collection__compare__bar--text compare__selected">
                     Compare up to 10 products
                     </p>`
                 }
                 <div class="collection__compare__bar--flex">
                 ${compareMap
                   .map(
                     (compare) => `<div class='compare__and__sku--container'>
                                    <div class='compare__and__sku--wrapper'>
                                      <div class="collection__compare__bar--images">
                                        <a href="/products/${compare.handle}">
                                          <img src=${compare.featured_image} class="collection__compare__bar--selected__product" alt='${compare.title}'/>
                                        </a>
                                        <div style='position:relative; top-0; left-[8px];'>
                                          <button class="collection__compare__bar--x js-removeProductFromCompare" data-id="${compare.id}" id="${compare.id}-removeProductFromCompare" aria-label='remove from compare list'>
                                            <svg 
                                              xmlns="http://www.w3.org/2000/svg" 
                                              fill="#575757" 
                                              width="100%" 
                                              height="100%" 
                                              version="1.1" 
                                              viewBox="144 144 512 512" 
                                              aria-label='x icon'
                                            >
                                              <path d="m563.32 236.68c-26.852-26.84-59.91-46.645-96.246-57.66-36.336-11.016-74.828-12.902-112.07-5.4922-37.238 7.4102-72.074 23.891-101.42 47.977-29.348 24.086-52.305 55.039-66.84 90.117-14.531 35.078-20.188 73.199-16.469 110.98 3.7148 37.785 16.691 74.07 37.781 105.64 21.086 31.574 49.637 57.461 83.117 75.367s70.859 27.281 108.83 27.293c61.219 0.078125 119.96-24.16 163.32-67.383 21.484-21.449 38.531-46.922 50.16-74.965 11.629-28.043 17.617-58.102 17.617-88.461 0-30.355-5.9883-60.418-17.617-88.457-11.629-28.043-28.676-53.516-50.16-74.965zm-74.312 222.73c3.9102 3.9336 6.1055 9.2539 6.1055 14.801 0 5.543-2.1953 10.863-6.1055 14.797-3.9297 3.9102-9.2539 6.1055-14.797 6.1055-5.5469 0-10.867-2.1953-14.801-6.1055l-59.406-59.406-59.41 59.406c-3.9336 3.9102-9.2539 6.1055-14.797 6.1055-5.5469 0-10.867-2.1953-14.801-6.1055-3.9102-3.9336-6.1055-9.2539-6.1055-14.797 0-5.5469 2.1953-10.867 6.1055-14.801l59.406-59.406-59.406-59.41c-3.4375-4.0156-5.2344-9.1797-5.0312-14.465 0.20312-5.2812 2.3945-10.293 6.1328-14.031s8.75-5.9297 14.031-6.1328c5.2852-0.20313 10.449 1.5938 14.465 5.0312l59.41 59.406 59.406-59.406c1.8828-2.1992 4.1992-3.9805 6.8008-5.2422 2.6055-1.2617 5.4414-1.9688 8.3359-2.0781 2.8906-0.11328 5.7695 0.375 8.4648 1.4297 2.6953 1.0547 5.1406 2.6562 7.1875 4.7031 2.043 2.043 3.6445 4.4922 4.7031 7.1836 1.0508 2.6953 1.5391 5.5781 1.4297 8.4688-0.11328 2.8906-0.82031 5.7266-2.082 8.332-1.2578 2.6055-3.043 4.9219-5.2422 6.8008l-59.406 59.41z"/>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                      <div class='product__identifier--collection' aria-label='SKU'>${compare.sku}</div>
                                    </div>
                                  </div>
                                  `
                   )
                   .join('\n')}
                   ${
                     selectedCompareProducts.length > 5
                       ? `<div class="collection__compare__bar--five__items__showing">+${
                           selectedCompareProducts.length - 5
                         }</div>`
                       : ''
                   }
                   ${
                     selectedCompareProducts.length > 2
                       ? `<div class="collection__compare__bar--two__items__showing">+${
                           selectedCompareProducts.length - 2
                         }</div>`
                       : ''
                   }
                  ${
                    selectedCompareProducts.length > 1
                      ? `<div class="collection__compare__bar--one__item__showing">+${
                          selectedCompareProducts.length - 1
                        }</div>`
                      : ''
                  }
                     </div>
                     <div class='compare__bar--buttons'>
                      <button class='collection__compare__bar--products__button js-compareButton' tabindex='0'>Compare</button>
                      <button class='collection__compare__bar--products__button js-hideCompareButton' tabindex='0'>Hide</button>
                     </div>
                 </div>
             </div>
         </div>
         `;
  }

  function init() {
    const compareProductsContainer = document.querySelector('.collection__compare-products');
    // Compare Bar
    compareProductsContainer.innerHTML = buildCompareBar();
    const selectedCompareProducts = JSON.parse(localStorage.getItem('selectedCompareProducts') || '[]');
    if (selectedCompareProducts.length === 0) {
      compareProductsContainer.style.display = 'none';
    }
    listen();
  }

  function listenToCompareBar() {
    /* remove product from compare selection with x button */
    const removeProductFromCompare = Array.from(document.querySelectorAll('.js-removeProductFromCompare'));
    for (const remover of removeProductFromCompare) {
      remover.addEventListener('click', () => {
        window.compareSlideOutHelper?.findIndex(remover.dataset.id);
        window.compareSlideOutHelper?.removeFromCompare(remover.dataset.id);
        updateCompareBar();
        window.compareSlideOutHelper?.checkIfInComparePDP();
        window.compareSlideOutHelper?.checkIfInSideBar();
        window.compareModal?.init();
      });
    }

    const compareButtons = Array.from(document.querySelectorAll('.js-compareButton'));
    for (const compareButton of compareButtons) {
      compareButton.addEventListener('click', () => {
        window.compareModal?.init();
        window.compareSlideOutHelper?.toggleModal();
        window.wishlistHelper?.check();
        document.querySelector('html').classList.add('stop-scroll');
      });
    }
    // const hideCompareBarButtons = Array.from(document.querySelectorAll('.js-hideCompareButton'));
    // for (const hideCompareBarButton of hideCompareBarButtons) {
    //   document.querySelector('.collection__compare__bar').style.display = 'none';
    //   this.banner.style.display = 'flex';
    window.compareBanner?.hideCompareBar();
    // }
    const banner = document.querySelector('.compare__banner');
    const hideCompareBarButtons = Array.from(document.querySelectorAll('.js-hideCompareButton'));
    for (const hideCompareBarButton of hideCompareBarButtons) {
      hideCompareBarButton.addEventListener('click', () => {
        window.compareBanner?.hideCompareBar();
      });
    }
  } // end of listenToCompareBar
  init();
  function listen() {
    listenToCompareBar();
  }

  // TABBING THROUGH AND CLOSING SHARE OPTIONS //
  const shareModalCloseBtns = Array.from(document.querySelectorAll('.pdp__main__share__close'));
  const shareModalCopyBtns = Array.from(document.querySelectorAll('.pdp__main__share__copy'));
  const firstBtns = Array.from(document.querySelectorAll('.st-btn.st-first.st-remove-label'));
  const middleBtns = Array.from(document.querySelectorAll('.st-btn.st-remove-label'));
  const lastBtns = Array.from(document.querySelectorAll('.st-btn.st-first.st-remove-label'));
  const focusableEls = [shareModalCloseBtns, shareModalCopyBtns, firstBtns, lastBtns, middleBtns];
  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];
  const KEYCODE_SPACE = 32;
  const KEYCODE_TAB = 9;
  const KEYCODE_ENTER = 13;
  const KEYCODE_ESCAPE = 27;
  const shareModal = document.querySelector('.pdp__main__share__wrapper');

  for (const firstBtn of firstBtns) {
    firstBtn.addEventListener('keydown', function (e) {
      const isSpaceOrEnterPressed =
        e.key === 'space' || e.keyCode === KEYCODE_SPACE || e.key === 'enter' || e.keycode === KEYCODE_ENTER;
      if (!isSpaceOrEnterPressed) {
        return;
      }
      if (isSpaceOrEnterPressed) {
        e.preventDefault();
        // firstBtn.click();
      }
    });
  }
  for (const lastBtn of lastBtns) {
    lastBtn.addEventListener('keydown', function (e) {
      const isSpaceOrEnterPressed =
        e.key === 'space' || e.keyCode === KEYCODE_SPACE || e.key === 'enter' || e.keycode === KEYCODE_ENTER;
      if (!isSpaceOrEnterPressed) {
        return;
      }
      if (isSpaceOrEnterPressed) {
        e.preventDefault();
        // lastBtn.click();
      }
    });
  }

  // closes modal if special character is pressed while on close button //
  for (const closeBtn of shareModalCloseBtns) {
    closeBtn.addEventListener('keydown', function (e) {
      const isSpaceOrEnterPressed =
        e.key === 'space' || e.keyCode === KEYCODE_SPACE || e.key === 'enter' || e.keycode === KEYCODE_ENTER;
      if (!isSpaceOrEnterPressed) {
        return;
      }
      if (isSpaceOrEnterPressed) {
        shareModal.replace('pdp__main__share__wrapper--open', 'pdp__main__share__close');
        e.preventDefault();
      }
    });
  }

  // cycles through focusable elements with tab and shift+tab //
  shareModal.addEventListener('keydown', function (e) {
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) {
      return;
    }
    if (e.shiftKey) {
      /* shift + tab */ if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } /* tab */ else {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  });

  // closes modal if one is open and the escape button is pressed //
  shareModal.addEventListener('keydown', function (e) {
    // if (shareModal) {
    if (shareModal?.classList.contains('.pdp__main__share__wrapper--open')) {
      if (e.key === 'Escape' || e.key === KEYCODE_ESCAPE) {
        shareModalCloseBtns.replace('pdp__main__share__wrapper--open', 'pdp__main__share__close');
      }
    }
    // }
  });

  // const descriptionShareTrigger = document.querySelector('.js-description-share-trigger');
  // document.addEventListener('keydown', function (event) {
  //   if (shareModal) {
  //     if (shareModal.classList.contains('.pdp__main__share__wrapper--open')) {
  //       if (event.key === 'Escape') {
  //         descriptionShareTrigger.nextElementSibling.classList.remove('pdp__main__share__wrapper--open');
  //       }
  //     }
  //   }
  // });
})();
